import React, { Fragment } from 'react';
import { Form, Radio } from 'antd';
import styled from 'styled-components';

const Label = styled.div`
  margin-bottom: ${({ inline }) => (inline ? '0' : '5px')};
  margin-right: ${({ inline }) => (inline ? '5px' : '0')};
  min-width: ${({ inline }) => (inline ? '30%' : '0')};
  color: ${({ hasError }) => (hasError ? '#f5222d' : '')};
`;

export default ({
  options = [],
  onChange,
  valueKey = 'id',
  labelKey = 'label',
  value,
  label,
  error,
  touched,
  inline = false,
  inlineLabelRows = false,
  disabled = false,
  ...rest
}) => {
  const RadioGroup = Radio.Group;
  const hasError = error && touched;

  const handleClick = optValue => {
    if (optValue === value) {
      onChange(null);
    }
  };

  return (
    <>
      {!!label && <label>{label}</label>}
      <Form.Item validateStatus={hasError ? 'error' : ''}>
        {hasError && (
          <Label inline={inline} hasError={hasError}>
            {hasError ? error : label}
          </Label>
        )}
        <RadioGroup {...rest} value={value} onChange={e => onChange(e.target.value)}>
          {options.map(opt => {
            const optValue = opt[valueKey];
            const optLabel = opt[labelKey];

            if (inlineLabelRows) {
              return (
                <div
                  key={optValue}
                  style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}
                >
                  <Radio
                    onClick={() => handleClick(optValue)}
                    value={optValue}
                    disabled={disabled || opt.disabled}
                  >
                    {optLabel}
                  </Radio>
                </div>
              );
            }

            return (
              <Fragment key={optValue}>
                {optLabel && <div>{optLabel}</div>}
                <Radio onClick={() => handleClick(optValue)} value={optValue} />
              </Fragment>
            );
          })}
        </RadioGroup>
      </Form.Item>
    </>
  );
};
